var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRkuitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 53,
    viewBox: "0 0 169 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78 22.71C8.32 22.76 8.08 23.04 8.08 23.55V51.71H0V20.54C0 19.42 0.17 18.6 0.52 18.06C0.87 17.52 1.6 17.02 2.72 16.56C6.16 15.3 10.48 14.6 15.68 14.46H20.07V21.87H15.4C12.8 21.87 10.59 22.15 8.78 22.71Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8599 15.51L44.3199 31.09C46.1299 32.02 47.7099 33.82 49.0599 36.47L56.6599 51.71H47.7399L42.3699 40.25C41.3499 38.11 39.5399 37.04 36.9299 37.04H32.7499V51.72H24.6699V0H32.7499V29.49H36.3699L47.0299 15.51H56.8599Z",
    fill: "#9D9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.62 15.51H91.7V49.27L88.98 50.32C84.98 51.95 80.43 52.77 75.32 52.77C70.21 52.77 66.74 51.57 64.35 49.17C61.96 46.77 60.76 43.29 60.76 38.72V15.51H68.84V38.43C68.84 43.04 71.37 45.35 76.44 45.35C78.86 45.35 80.99 45.07 82.85 44.51L83.62 44.3V15.51Z",
    fill: "#9D9D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.69 0.0200043H123.84V51.72H114.69V0.0200043Z",
    fill: "#0099D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.97 8.54V51.72H144.82V8.54H129.86V0.0200043H168.92V8.54H153.96H153.97Z",
    fill: "#0099D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRkuitLogo);
export default __webpack_public_path__ + "static/media/rkuit-logo.a2d6b122c634769854e626efd915c4a9.svg";
export { ForwardRef as ReactComponent };